import styled from "styled-components"

import { ReactComponent as IconDevice } from "assets/svg/icon-device.svg"

import { NOTES_MAX_LENGTH } from "utils/validationShemas"
import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"

const NotesWrapper = styled.div`
  margin-bottom: 16px;
`

const NotesTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 10px 12px;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  outline: none;
  color: #000;

  &:focus {
    border-color: #7864ff;
  }

  &::placeholder {
    color: #94a3b8;
  }
`

const NotesCounter = styled.div`
  text-align: right;
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 4px;
`

interface Props {
  notes: string
  onChange: (value: string) => void
}

const NotesSection = ({ notes, onChange }: Props) => {
  return (
    <>
      <ModalSectionTitle title="Notes" Icon={IconDevice} />
      <NotesWrapper>
        <NotesTextarea
          placeholder="Enter notes"
          value={notes}
          maxLength={NOTES_MAX_LENGTH}
          onChange={e => onChange(e.target.value)}
        />
        <NotesCounter>
          {notes.length} /{NOTES_MAX_LENGTH}
        </NotesCounter>
      </NotesWrapper>
    </>
  )
}

export default NotesSection
